module.exports = "<div class=\"page_loader\">\r\n  <div class=\"loader-container\">\r\n    <div class=\"loader\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/shared/components/loader/loader.component.html
// module id = ../../../../../src/app/shared/components/loader/loader.component.html
// module chunks = main